/** Ownership scope only: this ID never identifies a real circle or share target. */
export const TENANT_WIDE_SCOPE_ID = "00000000-0000-0000-0000-000000000000";

export const isTenantWideScope = (scopeID: string): boolean => scopeID === TENANT_WIDE_SCOPE_ID;

/** Only for query arguments whose API explicitly defines null/omitted as tenant-wide. */
export const normalizeTenantWideScopeArgument = (scopeID?: string | null): string => scopeID ?? TENANT_WIDE_SCOPE_ID;
